/* @flow */
import cx from 'classnames';
import React from 'react';

import ChatActions from 'chat/actions/ChatActions';
import ChatParticipantSearchMixin from 'components/mixins/ChatParticipantSearchMixin';
import DeprecatedTokenizerTypeahead from 'components/DeprecatedTokenizerTypeahead.jsx';
import getMatcher from 'utils/getMatcher';
import GroupStore from 'groups/stores/GroupStore';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import PotentialChatMember from 'entities/PotentialChatMember';
import ScrollableArea from 'components/ScrollableArea.jsx';
import Text from 'components/Text.jsx';
import { pushRouterToChatWithMember } from 'lib/ChatRouteHelper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showRecent, hideRecent } from 'reducers/recentMessagesModal';

import MessageStarterItem from './MessageStarterItem.jsx';

import styles from './styles/MessageStarter.css';

const IndividualMessageStarter = React.createClass({
  propTypes: {
    groupCode: React.PropTypes.string.isRequired,
    showRecent: React.PropTypes.func.isRequired,
    hideRecent: React.PropTypes.func.isRequired,
    onRequestHide: React.PropTypes.func,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    // TODO remove this mixin and convert to ES6 class
    // Only blocker is scrollToBottom load handling
    ChatParticipantSearchMixin,
  ],

  componentDidMount() {
    this.fetchData('');
  },

  // required by ChatParticipantSearchMixin
  _scrollableArea: null,

  getFilter(query: string) {
    const matcher = getMatcher(query);
    return (member: PotentialChatMember) => (
      matcher([
        member.getName(),
        member.getFirstName(),
        member.getLastName(),
        member.getNote(),
        member.getGroupNames(),
      ])
    );
  },

  fetchData(query: string) {
    return ChatActions
      .promisePotentialChatMembers(query)
      .then(coll => coll.getAvailableMembers());
  },

  // $FlowFixMe destructuring. Missing annotation
  startChatWithMember([member]) {
    const { groupCode, onRequestHide } = this.props;
    const group = GroupStore.getGroupForCode(groupCode);
    pushRouterToChatWithMember(this.context.router, this.props.showRecent, this.props.hideRecent, member, group);
    if (onRequestHide) {
      onRequestHide();
    }
  },

  renderInputToken() {
    // N/A because we're short-cutting out of tokenizing
    return <b>error</b>;
  },

  renderList(items: Array<*>, loading: boolean) {
    return (
      <ScrollableArea
        // required by ChatParticipantSearchMixin
        ref={(c) => (this._scrollableArea = c)}
        className={styles.scrollArea}
        onScroll={event => this.handleScroll(event)}>
        <ul>
          {items}
        </ul>
        {loading && <div className={styles.loadingIndicatorContainer}><LoadingIndicator /></div>}
      </ScrollableArea>
    );
  },

  renderNoResults(query: string) {
    return (
      <li className={styles.noResults} key="noResults">
        <Text color="pitch" size="xsmall" weight="semibold">
          No people found for &quot;{query}&quot;
        </Text>
      </li>
    );
  },

  renderMember(member: PotentialChatMember, highlighted: boolean,
    query: string, onSelect: Function) {
    return (
      <li
        onClick={() => onSelect()}
        key={member.id}>
        <MessageStarterItem
          className={cx({
            [styles.highlightedItem]: highlighted,
          })}
          member={member}
          query={query}
          selectable={false}
          selected={false}
        />
      </li>
    );
  },

  render() {
    return (
      <div className={cx(styles.this, this.props.className)}>
        <DeprecatedTokenizerTypeahead
          prompt="To:"
          placeholder="Choose or search for an individual"
          onChange={this.startChatWithMember}
          dataSource={this.fetchData}
          dataFilterFactory={this.getFilter}
          listRenderer={this.renderList}
          noResultsRenderer={this.renderNoResults}
          itemRenderer={this.renderMember}
          tokenRenderer={this.renderInputToken}
          autoFocus
          inline
        />
      </div>
    );
  },
});

const mapDispatchToProps = (dispatch: Function) =>
  bindActionCreators({
    showRecent,
    hideRecent,
  }, dispatch);

export { IndividualMessageStarter };
export default connect(undefined, mapDispatchToProps)(IndividualMessageStarter);



// WEBPACK FOOTER //
// ./src/chat/components/IndividualMessageStarter.jsx